import ProjectVideoTranscript from './ProjectVideoTranscript';
export default ProjectVideoTranscript;
